import { StorageService } from "./web-storage.service";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { RespuestaModel } from "../models/respuesta.model";
// import *  as configuration from '../../assets/conf/config.js';

@Injectable({
  providedIn: "root",
})
export class MainService {
  gatewayArchivos = "http://10.10.0.32:8083/";

  /* gatewayApi = ''
  gatewayApiBoveda = '' */
  configuracion: any;

  //PROD
  gatewayApiBoveda = 'https://simaf.conade.gob.mx/Microservicios/';
  gatewayApi = 'https://simaf.conade.gob.mx/Microservicios/';

  bovedaAPI = 'https://bovedav3.conade.gob.mx/servicios/api';
  //PREPROD
 // gatewayApi = "https://localhost:44362/";
  //gatewayApiBoveda = "https://localhost:44362/";

  //QA
  //gatewayApi = 'http://10.10.0.144:8099/';
  //gatewayApiBoveda = 'http://10.10.0.144:8099/';

  //DEV
  // gatewayApiBoveda = 'https://localhost:5001/';
  // gatewayApi = 'https://localhost:5001/';

  RENAPO = "https://wsrenapo.conade.gob.mx/Log/api/Renapo/";

  constructor(public httpClient: HttpClient) {}

  getAsync(url: string): Promise<any> {
    return new Promise((resolve) => {
      const subscription = this.httpClient.get<any>(url).subscribe(
        (data) => {
          subscription.unsubscribe();
          resolve(data);
        },
        (error) => {
          subscription.unsubscribe();
          resolve({
            EXITO: false,
            MENSAJE: error.message.toString(),
            RESPUESTA: error.error.text,
          } as RespuestaModel);
        },
      );
    });
  }

  postAsync(url: string, objeto: any): Promise<any> {
    return new Promise((resolve) => {
      const subscription = this.httpClient.post(url, objeto).subscribe(
        (data) => {
          subscription.unsubscribe();
          resolve(data ? data : ({ EXITO: true } as RespuestaModel));
        },
        (error) => {
          subscription.unsubscribe();
          return resolve({
            EXITO: false,
            MENSAJE: error.message.toString(),
            RESPUESTA: null,
          } as RespuestaModel);
        },
      );
    });
  }

  putAsync(url: string, objeto: any): Promise<any> {
    return new Promise((resolve) => {
      const subscription = this.httpClient.put(url, objeto).subscribe(
        (data) => {
          subscription.unsubscribe();
          resolve(data ? data : ({ EXITO: true } as RespuestaModel));
        },
        (error) => {
          subscription.unsubscribe();
          return resolve({
            EXITO: false,
            MENSAJE: error.message.toString(),
            RESPUESTA: null,
          } as RespuestaModel);
        },
      );
    });
  }

  deleteAsync(url: string): Promise<any> {
    return new Promise((resolve) => {
      const subscription = this.httpClient.delete<any>(url).subscribe(
        (data) => {
          subscription.unsubscribe();
          resolve(data ? data : ({ EXITO: true } as RespuestaModel));
        },
        (error) => {
          subscription.unsubscribe();
          resolve({
            EXITO: false,
            MENSAJE: error.message.toString(),
            RESPUESTA: null,
          } as RespuestaModel);
        },
      );
    });
  }

  get() {
    return new Promise((resolve) => {
      const subscription = this.httpClient
        .get("../../../../assets/datos/plantilla.json", {
          responseType: "text",
        })
        .subscribe(
          (data) => {
            subscription.unsubscribe();
            resolve(data);
          },
          (error) => {
            subscription.unsubscribe();
            resolve({
              EXITO: false,
              MENSAJE: error.message.toString(),
              RESPUESTA: error.error.text,
            } as RespuestaModel);
          },
        );
    });
  }

  obtenerUsuariosCSV_() {
    return new Promise((resolve) => {
      const subscription = this.httpClient
        .get("../../../../assets/datos/usuarios.json", { responseType: "text" })
        .subscribe(
          (data) => {
            subscription.unsubscribe();
            resolve(data);
          },
          (error) => {
            subscription.unsubscribe();
            resolve({
              EXITO: false,
              MENSAJE: error.message.toString(),
              RESPUESTA: error.error.text,
            } as RespuestaModel);
          },
        );
    });
  }

  async obtenerConfiguration() {
    let a = null;
    const subscription = this.httpClient
      .get("../../assets/conf/configuration.json")
      .subscribe((data) => {
        this.configuracion = data[0];
        // Asignación directa sin desencriptar
        this.gatewayApi = this.configuracion.urlServicio1;
        this.gatewayApiBoveda = this.configuracion.urlServicio1;
      });
    return a;
  }
}
